import "./styles.css";
import DoctorUserIcon from "../../../assets/svgs/DoctorUserIcon";
import { Button } from "@mui/material";
import { sxDoctorsCard } from "./sxProps";
import { DoctorsCardProps } from "../../../interfaces/props/SaudeOnline/DoctorsCardProps";
import { useEffect, useState } from "react";
import { Doctor } from "../../../interfaces/entities/Doctor";
import { defaultDoctor } from "./defaultStates";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function DoctorsCard(props: DoctorsCardProps) {
  const [day, setDay] = useState<string>("");
  const [month, setMonth] = useState<string>("");
  const [year, setYear] = useState<string>("");
  const [doctor, setDoctor] = useState<Doctor>(defaultDoctor);

  const accessibility = useAccessibility();

  useEffect(() => {
    setDoctor(props.doctor);
  }, [props.doctor]);

  useEffect(() => {
    if (props.doctor.dtDispon !== null) {
      const availability = props.doctor.dtDispon.split("/");

      setDay(availability[0]);
      setMonth(setMesNaData(availability[1]));
      setYear(availability[2]);
    }
  }, [props.doctor]);

  const setMesNaData = (monthNum: string) => {
    switch (monthNum) {
      case "01":
        return "Janeiro";
      case "02":
        return "Fevereiro";
      case "03":
        return "Março";
      case "04":
        return "Abril";
      case "05":
        return "Maio";
      case "06":
        return "Junho";
      case "07":
        return "Julho";
      case "08":
        return "Agosto";
      case "09":
        return "Setembro";
      case "10":
        return "Outubro";
      case "11":
        return "Novembro";
      case "12":
        return "Dezembro";
      default:
        return "Mês inválido";
    }
  };

  return (
    <Button
      variant="text"
      onClick={() => {
        props.handleSchedule(doctor);
      }}
      style={{ ...accessibility.contrastStyle, marginBottom: "16px" }}
      className="doctos-card-holder"
    >
      <div className="doctos-card">
        <div className="doctors-card-icon">
          <DoctorUserIcon />
        </div>
        <div className="doctors-card-info">
          <h1
            className="doctors-name"
            style={accessibility.textStyleAccessibility}
          >
            {doctor.nomePessoa}
          </h1>
          <span
            className="doctors-info"
            style={accessibility.textStyleAccessibility}
          >
            <b>Especialidade:</b> {doctor.descrEspec}
          </span>
          <span
            className="doctors-info"
            style={accessibility.textStyleAccessibility}
          >
            <b>Endereço:</b> {doctor.logradouro} {doctor.numero} {doctor.complemento}-{" "}
            {doctor.bairro}, {doctor.cidade} - {doctor.uf} / CEP: {doctor.cep}{" "}
          </span>
          <span
            className="doctors-info"
            style={accessibility.textStyleAccessibility}
          >
            <b>Telefone:</b> {doctor.telefone}
          </span>
          {props.doctor.dtDispon !== null && (
            <span
              className="doctors-info"
              style={accessibility.textStyleAccessibility}
            >
              <b>Provável disponibilidade:</b> {`${day} de ${month} de ${year}`}
            </span>
          )}
          <div>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                props.handleSchedule(doctor);
              }}
              style={{
                ...accessibility.buttonStyleAccessibility,
                ...accessibility.buttonTextStyleAccessibility,
              }}
              sx={sxDoctorsCard}
              aria-label={`agendar com ${doctor.nomePessoa}, especialista em ${doctor.descrEspec}, em ${doctor.logradouro} ${doctor.numero} -
              ${doctor.bairro}, ${doctor.cidade} - ${doctor.uf} / CEP: ${doctor.cep}}, contato ${doctor.telefone}`}
            >
              AGENDAR
            </Button>
          </div>
        </div>
      </div>
    </Button>
  );
}

export default DoctorsCard;
